export const QUICK_VIEW_LABELS = 'Browse.QuickView';

export const lblAddToBag = 'lbl_add_to_bag';
export const lblAvailableInMoreColors = 'lbl_available_in_more_colors';
export const lblEditItem = 'lbl_edit_item';
export const lblEditProduct = 'lbl_edit_product';
export const lblQuickViewError = 'lbl_quick_view_error';
export const lblQuickViewSorryMessage = 'lbl_quick_view_sorry_message';
export const lblViewProductDetails = 'lbl_view_product_details';
export const plpNoProductSelectedError = 'plp_no_product_selected_error';

export const quickViewLabels = {
  Browse: {
    QuickView: {
      [lblAddToBag]: 'Add To Bag',
      [lblAvailableInMoreColors]: 'Available in more colors!',
      [lblEditItem]: 'Edit Item',
      [lblEditProduct]: 'Edit Product',
      [lblQuickViewError]:
        'Your action could not be completed due to a system error. Please try again later',
      [lblQuickViewSorryMessage]: 'System Error',
      [lblViewProductDetails]: 'View Product Details',
      [plpNoProductSelectedError]: 'Please select products',
    },
  },
};
